<div class="dropdown" #buttonTarget [class.show]="isDropdownDisplayed">
    <button
        nbButton
        *ngIf="config?.button as button"
        (click)="toggleDropdown()"
        [disabled]="!(button.enable | async)"
        [outline]="button.outline || false"
        [status]="button.status || 'basic'"
    >
        <span *ngIf="button?.label">{{ button?.label }}</span>
        <nb-icon [icon]="isDropdownDisplayed ? 'chevron-up-outline' : 'chevron-down-outline'"></nb-icon>
    </button>

    <div class="dropdown-menu show" *ngIf="isDropdownDisplayed" ngxClickOutside (clickOutside)="onClickOutside($event)">
        <ng-container *ngTemplateOutlet="renderOptions; context: {$implicit: config.options}"></ng-container>

        <ng-template #renderOptions let-options>
            <div class="dropdown-submenu" *ngFor="let option of options">
                <ng-container *ngIf="option.disabled | async">
                    <div *ngIf="option.tooltip" [nbTooltip]="option.tooltip">
                        <ng-container
                            *ngTemplateOutlet="disabledDropdownItem; context: {$implicit: option}"
                        ></ng-container>
                    </div>
                    <div *ngIf="!option.tooltip">
                        <ng-container
                            *ngTemplateOutlet="disabledDropdownItem; context: {$implicit: option}"
                        ></ng-container>
                    </div>
                </ng-container>

                <ng-container *ngIf="!(option.disabled | async)">
                    <div
                        class="dropdown-item"
                        [class.parent]="option.children?.length"
                        (click)="onOptionClick(option, $event)"
                    >
                        <span class="ellipsis w-100">{{ option.label }}</span>
                        <nb-icon *ngIf="option.children?.length" icon="chevron-right-outline"></nb-icon>
                    </div>
                </ng-container>

                <div class="dropdown-menu" *ngIf="option.children?.length">
                    <ng-container
                        *ngTemplateOutlet="renderOptions; context: {$implicit: option.children}"
                    ></ng-container>
                </div>
            </div>
        </ng-template>

        <ng-template #disabledDropdownItem let-option>
            <div class="dropdown-item pointer-none">
                <span class="ellipsis w-100">{{ option.label }}</span>
                <nb-icon *ngIf="option.children?.length" icon="chevron-right-outline"></nb-icon>
            </div>
        </ng-template>
    </div>

    <div
        class="dropdown-menu show popover-container"
        ngxClickOutside
        (clickOutside)="onClickOutsidePopover($event)"
        [class.display-none]="!showingPopover"
    >
        <ng-template #popoverContainer></ng-template>
    </div>
</div>
